(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Shop mega menu
     The navigation is rendered by the Buddha Mega Menu app. Rather than
     change the app's saved menu (which the live theme shares), this folds
     the category dropdowns into the Shop panel on this theme only.
  --------------------------------------------------------------- */

  function lines(value) {
    return String(value || '').split(/\r?\n|,/).map(function (line) {
      return line.trim().toLowerCase();
    }).filter(Boolean);
  }

  function readConfig() {
    var config = {
      parent: 'shop',
      items: ['bridal', 'gowns', 'sarees for women', 'party dresses', 'darlytte'],
      keepTopLevel: true,
      nest: [{ child: 'resort', parent: 'darlytte' }],
      hide: ['geisha designs', 'luxury resort', 'collections']
    };
    var node = document.getElementById('gd-nav-config');
    if (!node) return config;
    try {
      var raw = JSON.parse(node.textContent);
      config.parent = String(raw.parent || 'Shop').trim().toLowerCase();
      config.items = lines(raw.items);
      config.keepTopLevel = raw.keepTopLevel !== false;
      config.hide = lines(raw.hide);
      config.nest = String(raw.nest || '').split(/\r?\n/).map(function (line) {
        var parts = line.split('>');
        if (parts.length !== 2) return null;
        return { child: parts[0].trim().toLowerCase(), parent: parts[1].trim().toLowerCase() };
      }).filter(function (rule) { return rule && rule.child && rule.parent; });
    } catch (error) {
      return config;
    }
    return config;
  }

  var CONFIG = readConfig();

  function ownText(el) {
    if (!el) return '';
    var text = '';
    el.childNodes.forEach(function (node) {
      if (node.nodeType === 3) text += node.textContent;
    });
    return text.replace(/\s+/g, ' ').trim();
  }

  function topTitle(li) {
    return ownText(li.querySelector(':scope > a .mm-title')).toLowerCase();
  }

  function linkData(a) {
    var title = a.querySelector('.mm-title') || a;
    var label = title.querySelector('.mm-label');
    return {
      text: ownText(title),
      href: a.getAttribute('href') || a.getAttribute('data-href') || '#',
      tag: label ? label.textContent.trim() : '',
      tagClass: label ? label.className.replace('mm-label', '').trim() : ''
    };
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function titleNode(className, column) {
    var node;
    if (column.href && column.href !== '#') {
      node = el('a', className, column.title);
      node.href = column.href;
    } else {
      node = el('span', className, column.title);
    }
    return node;
  }

  function linkList(links, className) {
    var list = el('ul', className);
    list.setAttribute('role', 'menu');
    links.forEach(function (link) {
      var li = el('li');
      li.setAttribute('role', 'none');
      var a = el('a', null, link.text);
      a.href = link.href;
      a.setAttribute('role', 'menuitem');
      if (link.tag) {
        a.appendChild(el('span', 'gd-tag gd-tag--' + (link.tagClass || 'new'), link.tag));
      }
      li.appendChild(a);
      list.appendChild(li);
    });
    return list;
  }

  function buildColumn(column, wide) {
    var col = el('div', 'gd-mega__col' + (wide ? ' gd-mega__col--wide' : ''));
    col.appendChild(titleNode('gd-mega__title', column));
    if (column.links.length) col.appendChild(linkList(column.links, 'gd-mega__links'));
    (column.children || []).forEach(function (child) {
      col.appendChild(titleNode('gd-mega__title gd-mega__subtitle', child));
      if (child.links.length) col.appendChild(linkList(child.links, 'gd-mega__links'));
    });
    return col;
  }

  function topItems(menu) {
    return Array.prototype.filter.call(menu.children, function (li) {
      return li.classList.contains('buddha-menu-item');
    });
  }

  function findItem(items, name) {
    return items.find(function (li) { return topTitle(li) === name; });
  }

  function shopColumns(panel) {
    return Array.prototype.map.call(panel.querySelectorAll(':scope > li[item-type="link-list"]'), function (li) {
      var name = li.querySelector('.mm-list-name [data-href]');
      return {
        title: ownText(li.querySelector('.mm-list-name .mm-title')),
        href: name ? name.getAttribute('data-href') : '',
        links: Array.prototype.map.call(li.querySelectorAll(':scope ul.mm-submenu > li > a'), linkData)
      };
    });
  }

  function itemData(li, twins) {
    var anchor = li.querySelector(':scope > a');
    var data = {
      title: ownText(anchor.querySelector('.mm-title')),
      href: anchor.getAttribute('href') || anchor.getAttribute('data-href') || '',
      links: Array.prototype.map.call(li.querySelectorAll(':scope > ul.mm-submenu > li > a'), linkData),
      children: []
    };
    if (!data.links.length && twins) {
      var twin = twins.find(function (c) { return c.title.toLowerCase() === data.title.toLowerCase(); });
      if (twin) data.links = twin.links;
    }
    return data;
  }

  /* Gathers everything once, before any DOM is changed, so the Shop panel's
     own columns (e.g. the Darlytte links) can feed items that have no
     dropdown of their own. */
  function collect(items, twins) {
    var data = {};
    items.forEach(function (li) {
      var name = topTitle(li);
      if (name) data[name] = itemData(li, twins);
    });
    CONFIG.nest.forEach(function (rule) {
      if (data[rule.child] && data[rule.parent]) data[rule.parent].children.push(data[rule.child]);
    });
    return data;
  }

  function addDropdown(li, column) {
    if (li.querySelector(':scope > .gd-dropdown')) return;
    var panel = el('div', 'gd-dropdown');
    var row = el('div', 'gd-dropdown__row');
    var own = { title: column.title, href: column.href, links: column.links, children: [] };
    row.appendChild(buildColumn(own, false));
    column.children.forEach(function (child) {
      row.appendChild(buildColumn({ title: child.title, href: child.href, links: child.links, children: [] }, false));
    });
    panel.appendChild(row);
    var existing = li.querySelector(':scope > ul.mm-submenu');
    if (existing) existing.classList.add('gd-replaced');
    li.appendChild(panel);
    li.classList.add('gd-has-dropdown');
    var anchor = li.querySelector(':scope > a');
    if (anchor && !anchor.querySelector('.mm-arrow')) {
      anchor.appendChild(el('i', 'mm-arrow mm-angle-down'));
    }
  }

  function foldMenu(menu) {
    var items = topItems(menu);
    var shop = findItem(items, CONFIG.parent);
    if (!shop || shop.classList.contains('gd-shop')) return;

    var panel = shop.querySelector(':scope > ul.mm-submenu');
    if (!panel) return;

    var twins = shopColumns(panel);
    var data = collect(items, twins);
    var nestedChildren = CONFIG.nest.map(function (rule) { return rule.child; });

    CONFIG.nest.forEach(function (rule) {
      var childLi = findItem(items, rule.child);
      var parentLi = findItem(items, rule.parent);
      if (childLi && parentLi && data[rule.parent]) {
        childLi.classList.add('gd-moved');
        addDropdown(parentLi, data[rule.parent]);
      }
    });

    var columns = [];
    CONFIG.items.forEach(function (name) {
      if (!data[name] || nestedChildren.indexOf(name) > -1) return;
      columns.push(data[name]);
      if (!CONFIG.keepTopLevel) {
        var li = findItem(items, name);
        if (li) li.classList.add('gd-moved');
      }
    });

    var used = CONFIG.items.concat(CONFIG.hide);
    var remaining = twins.filter(function (column) {
      return used.indexOf(column.title.toLowerCase()) === -1;
    });

    if (!columns.length && !remaining.length) return;

    var wrapper = el('div', 'gd-mega');
    wrapper.setAttribute('role', 'none');

    if (columns.length) {
      var primary = el('div', 'gd-mega__row');
      primary.style.setProperty('--gd-mega-cols', Math.max(columns.length, 4));
      columns.forEach(function (column) { primary.appendChild(buildColumn(column, false)); });
      wrapper.appendChild(primary);
    }

    if (remaining.length) {
      var secondary = el('div', 'gd-mega__row');
      remaining.forEach(function (column) {
        secondary.appendChild(buildColumn(column, column.links.length > 8));
      });
      wrapper.appendChild(secondary);
    }

    panel.innerHTML = '';
    panel.appendChild(wrapper);
    panel.removeAttribute('columns');
    panel.classList.add('gd-shop-panel');
    shop.classList.add('gd-shop');
  }

  /* Mobile (vertical) menu: groups are plain headed lists inside the
     app's own submenu, so the app's open/close toggle still works. */

  function mobileGroup(column) {
    var li = el('li', 'gd-m-group');
    li.appendChild(titleNode('gd-m-group__title', column));
    if (column.links.length) li.appendChild(linkList(column.links, 'gd-m-group__links'));
    (column.children || []).forEach(function (child) {
      li.appendChild(titleNode('gd-m-group__title gd-m-group__subtitle', child));
      if (child.links.length) li.appendChild(linkList(child.links, 'gd-m-group__links'));
    });
    return li;
  }

  function mobileDropdown(li, column) {
    if (li.querySelector(':scope > .gd-m-dropdown')) return;
    var anchor = li.querySelector(':scope > a');
    var button = el('button', 'gd-m-toggle');
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', column.title);
    var list = el('ul', 'gd-m-dropdown');
    list.hidden = true;
    list.appendChild(mobileGroup({ title: column.title, href: column.href, links: column.links, children: [] }));
    column.children.forEach(function (child) {
      list.appendChild(mobileGroup({ title: child.title, href: child.href, links: child.links, children: [] }));
    });
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var open = list.hidden;
      list.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
    });
    li.classList.add('gd-has-m-dropdown');
    if (anchor) anchor.insertAdjacentElement('afterend', button);
    li.appendChild(list);
  }

  function foldVerticalMenu(menu) {
    var items = topItems(menu);
    var shop = findItem(items, CONFIG.parent);
    if (!shop || shop.classList.contains('gd-shop-v')) return;

    var panel = shop.querySelector(':scope > ul.mm-submenu');
    if (!panel) return;

    var twins = shopColumns(panel);
    var data = collect(items, twins);
    var nestedChildren = CONFIG.nest.map(function (rule) { return rule.child; });

    CONFIG.nest.forEach(function (rule) {
      var childLi = findItem(items, rule.child);
      var parentLi = findItem(items, rule.parent);
      if (childLi && parentLi && data[rule.parent]) {
        childLi.classList.add('gd-moved');
        if (!parentLi.querySelector(':scope > ul.mm-submenu li')) mobileDropdown(parentLi, data[rule.parent]);
      }
    });

    var used = CONFIG.items.concat(CONFIG.hide);
    var keep = Array.prototype.filter.call(panel.querySelectorAll(':scope > li[item-type="link-list"]'), function (li) {
      return used.indexOf(ownText(li.querySelector('.mm-list-name .mm-title')).toLowerCase()) === -1;
    });

    var groups = [];
    CONFIG.items.forEach(function (name) {
      if (!data[name] || nestedChildren.indexOf(name) > -1) return;
      groups.push(mobileGroup(data[name]));
      if (!CONFIG.keepTopLevel) {
        var li = findItem(items, name);
        if (li) li.classList.add('gd-moved');
      }
    });

    Array.prototype.slice.call(panel.children).forEach(function (child) {
      if (keep.indexOf(child) === -1) child.remove();
    });
    groups.reverse().forEach(function (group) { panel.insertBefore(group, panel.firstChild); });

    shop.classList.add('gd-shop-v');
  }

  function foldAllMenus() {
    document.querySelectorAll('.horizontal-mega-menu').forEach(foldMenu);
    document.querySelectorAll('.vertical-mega-menu').forEach(foldVerticalMenu);
  }

  /* ---------------------------------------------------------------
     Currency switcher: dock the floating Webrex widget in the header bar
  --------------------------------------------------------------- */

  function dockCurrency() {
    var widget = document.getElementById('wsscc-main');
    var bar = document.querySelector('.header-tools');
    if (!widget || !bar || widget.classList.contains('gd-currency-docked')) return;
    if (!bar.offsetParent) return;
    bar.classList.add('gd-has-currency');
    bar.insertBefore(widget, bar.firstChild);
    widget.classList.add('gd-currency-docked');
  }

  /* ---------------------------------------------------------------
     Carousels: arrows (wrap around at the ends), wheel, drag, keyboard
  --------------------------------------------------------------- */

  function initCarousel(root) {
    if (root.dataset.gdReady) return;
    root.dataset.gdReady = 'true';

    var track = root.querySelector('[data-gd-carousel-track]');
    var prev = root.querySelector('[data-gd-carousel-prev]');
    var next = root.querySelector('[data-gd-carousel-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function refresh() {
      root.toggleAttribute('data-gd-static', maxScroll() <= 2);
      var figure = track.querySelector('figure, .product-list-item-thumbnail');
      if (figure) root.style.setProperty('--gd-arrow-top', figure.offsetHeight / 2 + 'px');
    }

    function go(direction) {
      var max = maxScroll();
      if (direction > 0 && track.scrollLeft >= max - 2) {
        track.scrollTo({ left: 0 });
      } else if (direction < 0 && track.scrollLeft <= 2) {
        track.scrollTo({ left: max });
      } else {
        track.scrollBy({ left: direction * step() });
      }
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); go(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(-1); }
    });

    var wheelLocked = false;
    track.addEventListener('wheel', function (event) {
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      var direction = Math.sign(event.deltaY);
      if (!direction) return;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll() - 1;
      if ((direction > 0 && atEnd) || (direction < 0 && atStart)) return;
      event.preventDefault();
      if (wheelLocked) return;
      wheelLocked = true;
      track.scrollBy({ left: direction * step() });
      setTimeout(function () { wheelLocked = false; }, 450);
    }, { passive: false });

    var drag = null;
    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x: event.clientX, left: track.scrollLeft, moved: false };
    });

    window.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5) {
        drag.moved = true;
        track.classList.add('is-dragging');
      }
      if (drag.moved) track.scrollLeft = drag.left - dx;
    });

    window.addEventListener('pointerup', function () {
      if (!drag) return;
      var moved = drag.moved;
      drag = null;
      if (!moved) return;
      track.classList.remove('is-dragging');
      var size = step();
      track.scrollTo({ left: Math.round(track.scrollLeft / size) * size });
      track.addEventListener('click', function swallow(event) {
        event.preventDefault();
        event.stopPropagation();
        track.removeEventListener('click', swallow, true);
      }, true);
    });

    window.addEventListener('resize', refresh);
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });
    refresh();
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-gd-carousel]').forEach(initCarousel);
  }

  /* ---------------------------------------------------------------
     Boot. The apps render late and sometimes re-render, so watch the DOM.
  --------------------------------------------------------------- */

  var pending = false;
  function run() {
    pending = false;
    foldAllMenus();
    dockCurrency();
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(run);
  }

  function setViewportWidth() {
    document.documentElement.style.setProperty('--gd-vw', document.documentElement.clientWidth + 'px');
  }

  function boot() {
    setViewportWidth();
    window.addEventListener('resize', setViewportWidth);
    initCarousels();
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCarousels(event.target);
  });
})();
